var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement_item"},[_c('div',{on:{"click":function($event){$event.preventDefault();return _vm.onClickCheck.apply(null, arguments)}}},[_c('CommonCheckbox',{staticClass:"checkbox",style:({
            height:'24px'
        }),scopedSlots:_vm._u([{key:"labelText",fn:function(){return [_c('div',{style:({
                    width: 'calc(100% - 98px)',
                    fontSize:'15px',
                    fontWeight: '400',
                    verticalAlign:'bottom',
                    lineHeight:'150%',
                    color:'#1a1a1a',
                    textOverflow: 'ellipsis',
                    marginLeft: '4px',
                      display: '-webkit-box',
                      webkitBoxOrient: 'vertical',
                      webkitLineClamp: '2',
                      overflow: 'hidden',
                      wordBreak: 'break-all',
                })},[_vm._v("\n                    "+_vm._s(_vm.agreement.question)+"\n                ")])]},proxy:true}]),model:{value:(_vm.isChecked),callback:function ($$v) {_vm.isChecked=$$v},expression:"isChecked"}})],1),_vm._v(" "),_c('button',{style:({
        position: 'absolute',top:'4px',right:'0'
    }),on:{"click":_vm.showDesc}},[(!_vm.isShowDesc)?[_c('span',{style:({
                fontSize:'14px',
                color:'#999'
            })},[_vm._v("상세보기"),_c('IconChevronDown',{style:({width:'12px', height:'12px'}),attrs:{"color":'#999999'}})],1)]:[_c('span',{style:({
                fontSize:'14px',
                color:'#999'
            })},[_vm._v("상세보기"),_c('IconChevronDown',{style:({width:'12px', height:'12px',transform:'rotate(180deg)'}),attrs:{"color":'#999999'}})],1)]],2),_vm._v(" "),(_vm.isShowDesc)?_c('div',{style:({
        overflow:'hidden',
        marginTop: '6px',
        width:'100%',
        height: '100px',
        border: '1px solid #ccc',
        borderRadius: '5px',
            boxSizing:'border-box'
    })},[_c('textarea',{style:({
            width:'100%',
            height: '100%',
            lineHeight: '150%',
            fontSize: '12px',
            padding:'13px 16px',
            boxSizing:'border-box',
            border:'none',
            color:'#666',
        }),attrs:{"readonly":""},domProps:{"value":_vm.agreement.questionDesc}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }